module.exports = __webpack_public_path__ + "static/media/JS.c3a881d6.svg";